import { Grid, Typography, withStyles } from "@material-ui/core";
import MuiTableCell from "@material-ui/core/TableCell";
import MuiTableRow from "@material-ui/core/TableRow";
import { Select } from "@ofqual/portal-components/components/Select";
import React from "react";
import { ApprovalStatusSelectOptions } from "../../../../domain/ApprovalStatusSelectOptions";
import { ApprovalStatus } from "../../../../domain/ApprovalSubject";
import {
  IEvaluationApprovalCardProps,
  handleSetApprovalSubject,
} from "../utils";

const TableCell = withStyles({
  root: {
    borderBottom: "none",
    padding: "2px",
  },
})(MuiTableCell);

const TableRow = withStyles({
  root: {
    padding: 0,
  },
})(MuiTableRow);

export const IndustryApprovalCard: React.FC<IEvaluationApprovalCardProps> = ({
  subject,
  matchingLevel,
  approvalSubjects,
  setApprovalSubjects,
  dataTest,
  readOnly
}) => {
  const approvalSubject = approvalSubjects.find(
    (s) => s.subjectId === subject.id
  );

  return (
    <>
      <TableRow>
        <TableCell colSpan={2}>
          <Grid item xs={12} sm={3}>
            <Typography variant="body1" data-testid="data-card-key">
              <strong>Status</strong>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Select
              size="small"
              value={
                approvalSubject?.levels.find(
                  (l) => l.levelId === matchingLevel.id
                )?.evaluationResults!.industryAssessment?.approvalStatus
              }
              onChange={(e) =>
                handleSetApprovalSubject(
                  subject.id,
                  matchingLevel.id,
                  "industryAssessment",
                  e.target.value as unknown as ApprovalStatus,
                  approvalSubjects,
                  setApprovalSubjects
                )
              }
              data-test={`industry-assessment-${dataTest}`}
              readOnly={readOnly}
              label={""}
            >
              {ApprovalStatusSelectOptions()}
            </Select>
          </Grid>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={2}>&nbsp;</TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={2}>
          <hr />
        </TableCell>
      </TableRow>
    </>
  );
};
